import { Outlet } from 'react-router-dom';
import PrivateNavbar from '../components/PrivateNavbar'; // You'll build this next
import Footer from '../components/Footer';

function PrivateLayout() {
    return (
        <>
            <PrivateNavbar />
            <Outlet />
            <Footer />
        </>
    );
}

export default PrivateLayout;